import React, { useEffect, useState } from "react";
import { tvFloorOps } from "../../lib/api";
import { agoCt } from "../floor/useHouseLive";
import { FloorAvatar } from "./FloorAvatar";

const SEATS = [
  { id: "scott", ids: ["scott"], name: "Mr Scott", role: "Scout" },
  { id: "minyo", ids: ["minyo"], name: "Mr Minyo", role: "Small-Cap Scout" },
  { id: "jimmy", ids: ["jimmy"], name: "Mr Jimmy", role: "Analyst" },
  { id: "funda", ids: ["funda"], name: "Mr Funda", role: "Fundamentalist" },
  { id: "prakash", ids: ["prakash"], name: "Mr Prakash", role: "Technician" },
  { id: "crams", ids: ["crams"], name: "Mr Crams", role: "Validator" },
  { id: "debate", ids: ["london", "tariq"], name: "London vs Tariq", role: "Bull / Bear" },
  { id: "genie", ids: ["genie"], name: "Mr Genie", role: "Confirmer" },
  { id: "oracle", ids: ["oracle", "kalshi_desk"], name: "Ms Oracle + Kalshi Desk", role: "Kalshi Probability Desk · CPI watch" },
];
const IDLE_MS = 30 * 60000;
const lastAt = (s) => (s?.recent || [])[0]?.finished_at || s?.started_at;

const Card = ({ seat, s }) => {
  const at = lastAt(s), idle = !at || Date.now() - Date.parse(at) >= IDLE_MS;
  const c = idle ? "#FF3D68" : "#2CF6B3";
  return (
    <div className="nx-hud rounded-2xl p-4 flex flex-col gap-2 min-h-0 overflow-hidden" style={{ borderColor: `${c}88`, boxShadow: idle ? "0 0 18px #FF3D6844" : "none" }} data-testid={`tv-team-${seat.id}`}>
      <div className="flex items-center gap-3 min-w-0">
        <FloorAvatar agent={seat.ids[0]} size={44} glow={!idle} />
        <div className="min-w-0 flex-1"><p className="nx-orbitron font-black text-lg truncate text-cyan-50">{seat.name}</p><p className="text-xs text-cyan-200/50 truncate">{seat.role}</p></div>
        <span className="nx-mono text-sm font-bold rounded-full px-3 py-1 shrink-0" style={{ color: c, border: `1px solid ${c}`, background: `${c}18` }} data-testid={`tv-team-status-${seat.id}`}>
          {idle ? "IDLE" : `WORKING · ${s?.status || ""}`}</span>
      </div>
      <p className="text-base text-cyan-50 leading-snug line-clamp-3" data-testid={`tv-team-task-${seat.id}`}><span className="text-cyan-300/60 nx-mono text-xs">NOW </span>{s?.task || "—"}</p>
      <p className="text-sm text-cyan-100/70 leading-snug line-clamp-2 mt-auto" data-testid={`tv-team-last-${seat.id}`}>
        <span className="nx-mono text-xs" style={{ color: c }}>LAST {at ? agoCt(at) : "—"} </span>{(s?.recent || [])[0]?.result || s?.result || "—"}</p>
    </div>
  );
};

export const TvHouseTeam = () => {
  const [agents, setAgents] = useState([]);
  useEffect(() => {
    const load = () => tvFloorOps().then((r) => setAgents(r.agents || [])).catch(() => {});
    load(); const t = setInterval(load, 15000); return () => clearInterval(t);
  }, []);
  const by = Object.fromEntries(agents.map((a) => [a.agent, a]));
  const pick = (seat) => seat.ids.map((i) => by[i]).filter(Boolean).sort((a, b) => (lastAt(b) || "").localeCompare(lastAt(a) || ""))[0];
  return (
    <div className="h-full flex flex-col gap-4" data-testid="tv-scene-team">
      <p className="nx-orbitron text-2xl font-black tracking-widest text-[#00F0FF]">THE HOUSE TEAM <span className="text-sm text-cyan-200/50 font-normal tracking-normal">live tasks · red = no action for 30 min</span></p>
      <div className="flex-1 min-h-0 grid grid-cols-5 grid-rows-2 gap-4">{SEATS.map((seat) => <Card key={seat.id} seat={seat} s={pick(seat)} />)}</div>
    </div>
  );
};
